import React, { useEffect, useRef } from 'react';

/**
 * Lightweight TradingView widget embed. Pure iframe via the symbol-overview
 * and advanced chart URL — no script required, no external fetch on load.
 */
export default function TradingViewWidget({ symbol = 'AAPL', height = 420 }) {
  const containerRef = useRef(null);
  useEffect(() => {
    if (!containerRef.current) return;
    containerRef.current.innerHTML = '';
    const script = document.createElement('script');
    script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js';
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = JSON.stringify({
      autosize: true,
      symbol: symbol,
      interval: 'D',
      timezone: 'Etc/UTC',
      theme: 'dark',
      style: '1',
      locale: 'en',
      toolbar_bg: '#050505',
      enable_publishing: false,
      hide_top_toolbar: false,
      hide_legend: false,
      save_image: false,
      allow_symbol_change: true,
      calendar: false,
      support_host: 'https://www.tradingview.com',
    });
    containerRef.current.appendChild(script);
  }, [symbol]);

  return (
    <div className="tradingview-widget-container" style={{ height }} data-testid="tradingview-widget">
      <div ref={containerRef} className="tradingview-widget-container__widget" style={{ height }} />
    </div>
  );
}
